import { NavIconName } from './NavIcon';

// The six top-level sections and the routes that belong to each, so pages outside a
// section's own path still highlight it (an MK page lives under הכנסת).

export interface NavSubItem {
  label: string;
  to: string;
  isActive: (pathname: string, search: URLSearchParams) => boolean;
}

export interface NavSection {
  key: string;
  label: string;
  to: string;
  icon: NavIconName;
  prefixes: string[];
  // Desktop sidebar: a section's URL-addressable tabs (?tab=…), listed under it when active
  subItems?: NavSubItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    key: 'knesset', label: 'הכנסת', to: '/parties', icon: 'knesset', prefixes: ['/parties', '/members'],
    subItems: [
      { label: 'סיעות', to: '/parties', isActive: (p, s) => p.startsWith('/parties/') || (p === '/parties' && s.get('tab') !== 'members' && s.get('tab') !== 'presence') },
      { label: 'חברי כנסת', to: '/parties?tab=members', isActive: (p, s) => p.startsWith('/members/') || (p === '/parties' && s.get('tab') === 'members') },
      { label: 'במשכן', to: '/parties?tab=presence', isActive: (p, s) => p === '/parties' && s.get('tab') === 'presence' },
    ],
  },
  {
    key: 'government', label: 'הממשלה', to: '/government', icon: 'government', prefixes: ['/government'],
    subItems: [
      { label: 'שרים', to: '/government', isActive: (p, s) => p === '/government' && !s.get('tab') },
      { label: 'משרדים', to: '/government?tab=ministries', isActive: (p, s) => p.startsWith('/government/ministries/') || (p === '/government' && s.get('tab') === 'ministries') },
      { label: 'חקיקה ממשלתית', to: '/government?tab=bills', isActive: (p, s) => p === '/government' && s.get('tab') === 'bills' },
    ],
  },
  { key: 'legislation', label: 'חקיקה', to: '/legislation', icon: 'legislation', prefixes: ['/legislation'] },
  {
    key: 'committees', label: 'ועדות', to: '/committees', icon: 'committees', prefixes: ['/committees', '/lobbyists'],
    subItems: [
      { label: 'ועדות', to: '/committees', isActive: (p, s) => p.startsWith('/committees/') || (p === '/committees' && s.get('tab') !== 'lobbyists') },
      { label: 'שדלנים', to: '/committees?tab=lobbyists', isActive: (p, s) => p.startsWith('/lobbyists') || (p === '/committees' && s.get('tab') === 'lobbyists') },
    ],
  },
  {
    // Two pages under one heading that keeps its name (owner's 5d-A, 2026-10-17)
    key: 'queries', label: 'שאילתות', to: '/queries', icon: 'queries', prefixes: ['/queries'],
    subItems: [
      { label: 'שאילתות', to: '/queries', isActive: (p, s) => p.startsWith('/queries/') || (p === '/queries' && s.get('tab') !== 'motions') },
      { label: 'הצעות לסדר היום', to: '/queries?tab=motions', isActive: (p, s) => p === '/queries' && s.get('tab') === 'motions' },
    ],
  },
  { key: 'schedule', label: 'לו"ז', to: '/schedule', icon: 'schedule', prefixes: ['/schedule'] },
];

export const sectionForPath = (pathname: string): NavSection | undefined =>
  NAV_SECTIONS.find(s => s.prefixes.some(p => pathname === p || pathname.startsWith(`${p}/`)));
